import React from "react";
import * as SubframeCore from "@subframe/core";

interface HeaderProps {
  userName: string;
}

export const Header: React.FC<HeaderProps> = ({ userName }) => {
  return (
    <>
      <div className="flex h-16 w-full flex-none items-center gap-2 px-4 sm:px-6 md:pl-12 md:pr-6 py-4">
        <SubframeCore.Icon
          className="text-body font-body text-default-font"
          name="FeatherHome"
        />
        <span className="text-body font-body text-neutral-700">Home</span>
      </div>
      <div className="flex w-full flex-col items-center gap-4 px-4 sm:px-6 md:pl-12">
        <div className="flex w-full flex-col items-start gap-4">
          <span className="text-header font-header text-default-font">
            Good morning, {userName} 👋
          </span>
          <span className="text-body font-body text-default-font">
            Here is an overview of what&#39;s on your plate.
          </span>
        </div>
      </div>
    </>
  );
}; 